import { profileNameMaxChars } from "./data"

/**
 * Maximum number of connected pads (physical or virtual) on the website
 */
export const MAX_CONNECTED_PADS = 4

/**
 * Centralized breakpoint definitions (in pixels).
 * Keep them in one place so you can reuse them in hooks, components, and CSS-in-JS.
 */
export const BREAKPOINTS = {
  MOBILE: 480,
  TABLET: 768,
  LAPTOP: 1024,
  DESKTOP: 1280,
  WIDE: 1440,
  FULL_HD: 1920
} as const

// Optional helper types
export type BreakpointKey = keyof typeof BREAKPOINTS
export type BreakpointValue = (typeof BREAKPOINTS)[BreakpointKey]

export const PROFILE_NAME_MAX_CHARS = profileNameMaxChars

export const LOCALE_PREFIX_RE = /^\/([a-z]{2}(?:-[A-Z]{2})?)(?=\/|$)/

/**
 * List of pages where the full menu should be hidden.
 */
export const HIDDEN_FULL_MENU_PAGES: string[] = [
  '/html5',
  '/cookies',
  '/eula',
  '/legal',
  '/privacy',
  '/offline'
]

/**
 * List of pages where the main menu should be hidden.
 */
export const HIDDEN_MENU_PAGES: string[] = [
  '/login',
  '/forgot-password',
  '/select-profile',
  '/add-profile',
  '/sign-up',
  '/verify-email',
  '/billing/choose-plan',
  '/html5',
  '/complete-account'

]

/**
 * List of public pages.
 */
export const PUBLIC_ROUTES: string[] = [
  '/',
  '/cookies',
  '/eula',
  '/forgot-password',
  '/games',
  '/legal',
  '/login',
  '/our-apps',
  '/privacy',
  '/sign-up',
  '/catalogue',
  '/home',
  '/verify-email',
  '/collection',
  '/promo/telekom-action',
  '/complete-account',
  
]

export const IMAGE_WIDTH_HORIZONTAL = 800
export const IMAGE_HEIGHT_HORIZONTAL = 384
export const IMAGE_WIDTH_VERTICAL = 512
export const IMAGE_HEIGHT_VERTICAL = 768

export const CUSTOM_SUPPORT_WIDGET_URL = ''

export const FEATURES = {
  accountSubscription: process.env.NEXT_PUBLIC_FEATURE_ACCOUNT_SUBSCRIPTION === 'true',
  discoverBanner: process.env.NEXT_PUBLIC_FEATURE_DISCOVER_BANNER === 'true',
  speedTest: process.env.NEXT_PUBLIC_FEATURE_SPEEDTEST === 'true',
  login: process.env.NEXT_PUBLIC_FEATURE_LOGIN === 'true',
  loginExternal: process.env.NEXT_PUBLIC_FEATURE_LOGIN_EXTERNAL === 'true',
  signUp: process.env.NEXT_PUBLIC_FEATURE_SIGN_UP === 'true',
  signUpExternal: process.env.NEXT_PUBLIC_FEATURE_SIGN_UP_EXTERNAL === 'true',
  signUpExternalDynamic: process.env.NEXT_PUBLIC_FEATURE_SIGN_UP_EXTERNAL_DYNAMIC === 'true',
  billingFreeTrial: process.env.NEXT_PUBLIC_FEATURE_BILLING_FREE_TRIAL === 'true',
  changePassword: process.env.NEXT_PUBLIC_FEATURE_CHANGE_PASSWORD === 'true',
  changePasswordExternal: process.env.NEXT_PUBLIC_FEATURE_CHANGE_PASSWORD_EXTERNAL === 'true',
  changePasswordExternalDynamic: process.env.NEXT_PUBLIC_FEATURE_CHANGE_PASSWORD_DYNAMIC === 'true',
  recoverPassword: process.env.NEXT_PUBLIC_FEATURE_RECOVER_PASSWORD === 'true',
  recoverPasswordExternal: process.env.NEXT_PUBLIC_FEATURE_RECOVER_PASSWORD_EXTERNAL === 'true',
  recoverPasswordExternalDynamic: process.env.NEXT_PUBLIC_FEATURE_RECOVER_PASSWORD_EXTERNAL_DYNAMIC === 'true',
  changeLanguage: process.env.NEXT_PUBLIC_FEATURE_CHANGE_LANGUAGES === 'true',
  newsletter: process.env.NEXT_PUBLIC_FEATURE_NEWSLETTER === 'true',
  changePreferredLang: process.env.NEXT_PUBLIC_FEATURE_CHANGE_PREFERRED_LANG === 'true',
  unsubscribe: process.env.NEXT_PUBLIC_FEATURE_UNSUBSCRIBE === 'true',
  unsubscribeSubmenu: process.env.NEXT_PUBLIC_FEATURE_UNSUBSCRIBE_SUBMENU === 'true',
  unsubscribeAccount: process.env.NEXT_PUBLIC_FEATURE_UNSUBSCRIBE_ACCOUNT === 'true',
  unsubscribeExternal: process.env.NEXT_PUBLIC_FEATURE_UNSUBSCRIBE_EXTERNAL === 'true',
  unsubscribeExternalDynamic: process.env.NEXT_PUBLIC_FEATURE_UNSUBSCRIBE_EXTERNAL_DYNAMIC === 'true',
  unsubscribeExternalLogout: process.env.NEXT_PUBLIC_FEATURE_UNSUBSCRIBE_EXTERNAL_LOGOUT === 'true',
  addProfile: process.env.NEXT_PUBLIC_FEATURE_ADD_PROFILE === 'true',
  socialMedia: process.env.NEXT_PUBLIC_FEATURE_SOCIAL_MEDIA === 'true',
  eula: process.env.NEXT_PUBLIC_FEATURE_EULA === 'true',
  privacy: process.env.NEXT_PUBLIC_FEATURE_PRIVACY === 'true',
  cookies: process.env.NEXT_PUBLIC_FEATURE_COOKIES === 'true',
  legalNotice: process.env.NEXT_PUBLIC_FEATURE_LEGAL_NOTICE === 'true',
  helpCenter: process.env.NEXT_PUBLIC_FEATURE_HELP_CENTER === 'true',
  helpCenterOnFooter: process.env.NEXT_PUBLIC_FEATURE_HELP_CENTER_FOOTER === 'true',
  ludiumContact: process.env.NEXT_PUBLIC_FEATURE_LUDIUM_LINK === 'true',
  virtualPads: process.env.NEXT_PUBLIC_FEATURE_VIRTUALPADS === 'true',
  virtualPadsBeta: process.env.NEXT_PUBLIC_FEATURE_VIRTUALPADS_BETA === 'true',
  customSupportWidget: process.env.NEXT_PUBLIC_FEATURE_CUSTOM_SUPPORT_WIDGET === 'true'
}

export const supportLinks: Record<string, string> = {
  'ca-ES': 'https://support.sorastream.com/',
  'de-DE': 'https://support.sorastream.com/',
  'en-US': 'https://support.sorastream.com/',
  'es-ES': 'https://support.sorastream.com/',
  'fr-FR': 'https://support.sorastream.com/',
  'it-IT': 'https://support.sorastream.com/',
  'pt-BR': 'https://support.sorastream.com/',
  'ar-JO': 'https://support.sorastream.com/'
}